import {FETCH_PACKAGES} from '../actions/actionTypes';
import slugify from 'slugify';

const INITIAL_STATE = { packages: [] };

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case FETCH_PACKAGES + '_FULFILLED':
            return { ...state, packages: updateLoadedPackages(action.payload.data) };

        default:
            return state;
    }
}

function updateLoadedPackages(packages) {
    packages.map(pckg => {
        pckg.tags = pckg.tags ? slugify(pckg.tags.toString()) : '';
    });
    return packages;
}
